import { showApiErrors } from '@/utils';
import { createSlice, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';
import { deletePropertyPhoto, getPropertyPhotos, uploadPropertyPhotos } from './actionCreators';
import { initialState, PICTURES_SLICE_NAME, PictureState } from './models';

export const slice = createSlice({
  name: PICTURES_SLICE_NAME,
  initialState,
  reducers: {
    resetState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        isFulfilled(getPropertyPhotos, deletePropertyPhoto, uploadPropertyPhotos),
        (state: PictureState, action) => {
          const { payload } = action;
          state.isLoading = false;
          state.error = null;
          state.propertyPhotosInside = payload.photos_inside;
          state.propertyPhotosOutside = payload.photos_outside;
          state.floorPlan = payload.floor_plan;
        },
      )
      .addMatcher(isPending(getPropertyPhotos, deletePropertyPhoto, uploadPropertyPhotos), (state: PictureState) => {
        state.isLoading = true;
        state.error = null;
      })
      .addMatcher(
        isRejected(getPropertyPhotos, deletePropertyPhoto, uploadPropertyPhotos),
        (state: PictureState, action) => {
          const error = action?.error;
          state.isLoading = false;
          state.error = error;

          showApiErrors(error);
        },
      );
  },
});

export default slice.reducer;

export const { resetState } = slice.actions;
